<template>
  <div class="footer">
    <div class="company-bar">
      <studio-logo id="overlook" :max="3"/>
    </div>
    <div class="copyright text-glow">Overlook Studios © 2019-2023</div>
  </div>
</template>

<script>
import StudioLogo from '@/components/studio-logo.vue'
export default {
  components: {
    StudioLogo,
  },
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";
.footer {
  width: 100%;
  margin-top: 150px;
}
.company-bar {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.copyright {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 20px;
  color: $text-color;
}

.company-bar .company {
  cursor: pointer;
  transition: all 0.5s;
  opacity: 0.7;
}

.company {
  width: 80%;
  max-width: 400px;
}

.company-bar .company:hover {
  filter: drop-shadow(0px 0px 10px rgba($green, 0.1));
  transition: all 0.5s;
  opacity: 0.9;
}

//  to show the social media bar
@media only screen and (max-width: 900px) {
  .footer {
    margin-bottom: 100px;
  }
}
#overlook > img{
  filter: saturate(0.3);
}
</style>
